<template>
  <div class="clara-section">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <a href="https://app.clara.cc" target="_blank">
            <h4 class="client">Clara</h4>
          </a>
          <h1 class="title">
            {{ $t("clara.title") }}
          </h1>
          <p class="date">
            {{ $t("clara.duration.title") }}
            {{ $t("clara.duration.date") }}
          </p>
          <p class="role">
            {{ $t("clara.position.title") }}
            {{ $t("clara.position.role") }}
          </p>
          <p class="description">
            {{ $t("clara.description") }}
          </p>
          <ul class="menu-list">
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("clara.bullet1") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("clara.bullet2") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("clara.bullet3") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("clara.bullet4") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("clara.bullet5") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("clara.bullet6") }}
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <div class="panel-stack">
            <div class="impact-panel">
              <div class="impact-panel__sidebar">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="impact-panel__content">
                <div class="impact-panel__header">
                  <span class="impact-panel__eyebrow">Clara</span>
                  <strong>{{ $t("clara.visual.title") }}</strong>
                </div>
                <div class="impact-panel__alert"></div>
                <div class="impact-panel__grid">
                  <div class="impact-panel__item">
                    <span>{{ $t("clara.visual.products") }}</span>
                    <strong>18</strong>
                  </div>
                  <div class="impact-panel__item">
                    <span>{{ $t("clara.visual.stack") }}</span>
                    <strong>React</strong>
                  </div>
                  <div class="impact-panel__item">
                    <span>{{ $t("clara.visual.focus") }}</span>
                    <strong>MF</strong>
                  </div>
                </div>
                <div class="impact-panel__tags">
                  <span>Product Enable</span>
                  <span>Approvals Flows</span>
                  <span>Fintech</span>
                </div>
              </div>
            </div>
            <div class="chat-panel">
              <div class="chat-panel__topbar">
                <span></span>
                <strong>{{ $t("clara.chat.title") }}</strong>
              </div>
              <div class="chat-panel__conversation">
                <div class="chat-panel__message chat-panel__message--user">
                  {{ $t("clara.chat.userMessage") }}
                </div>
                <div class="chat-panel__message chat-panel__message--agent">
                  {{ $t("clara.chat.agentMessage1") }}
                </div>
                <div class="chat-panel__insight">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div class="chat-panel__message chat-panel__message--agent">
                  {{ $t("clara.chat.agentMessage2") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "animate.css";
import WOW from "wow.js";

export default {
  name: "Clara",
  components: {},
  mounted() {
    new WOW().init();
  },
};
</script>

<style lang="scss" scoped>
div.clara-section {
  background: #f6f8fb;
  color: #111820;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;

  @media (min-width: 600px) {
    padding: 0;
    min-height: 100vh;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    max-width: 48rem;
    padding: 2.5rem;

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      font-weight: 800;
      color: #008a78;
      margin-bottom: 0.35rem;
    }

    h1.title {
      color: #111820;
      font-size: clamp(2rem, 3vw, 3.4rem);
      font-weight: 800;
      line-height: 1.05;
      margin-bottom: 1.75rem;
      text-align: left;
    }

    p.date,
    p.role {
      text-align: left;
      font-weight: 700;
      color: #53606d;
      font-size: 1.08rem;
      line-height: 1.4;
      margin-bottom: 0.2rem;
    }

    p.description {
      text-align: left;
      font-weight: 700;
      color: #1f2933;
      font-size: 1.05rem;
      line-height: 1.65;
      margin: 2rem 0 1.5rem;
    }

    ul {
      color: #3d4752;
      list-style: none;
      padding-left: 0;

      li {
        line-height: 1.45;
        margin: 0.8rem 0;
        padding-left: 1.2rem;
        position: relative;
        text-align: left;

        &::before {
          content: "";
          width: 0.35rem;
          height: 0.35rem;
          border-radius: 50%;
          background: #008a78;
          left: 0;
          position: absolute;
          top: 0.6rem;
        }
      }
    }
  }

  div.multimedia-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
  }

  div.panel-stack {
    width: min(62rem, 94%);
    min-height: 41rem;
    position: relative;
  }

  div.chat-panel {
    width: min(25rem, 42%);
    border: 1px solid #d9dee7;
    border-radius: 26px;
    background: #ffffff;
    box-shadow: 0 1.5rem 4rem rgba(31, 52, 79, 0.12);
    overflow: hidden;
    position: absolute;
    right: 0;
    bottom: -4%;
    transform: rotate(1deg);
    z-index: 3;

    &::before {
      content: "";
      width: 5.2rem;
      height: 0.35rem;
      border-radius: 999px;
      background: #40516a;
      left: 50%;
      position: absolute;
      top: 0.75rem;
      transform: translateX(-50%);
      z-index: 2;
    }
  }

  div.chat-panel__topbar {
    align-items: center;
    background: #1f344f;
    color: #ffffff;
    display: flex;
    gap: 0.75rem;
    padding: 1.7rem 1.25rem 1rem;

    span {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      background: #8d49ff;
      box-shadow: 0 0 0 0 rgba(141, 73, 255, 0.5);
      animation: chat-pulse 2s ease-in-out infinite;
    }

    strong {
      font-size: 0.95rem;
    }
  }

  div.chat-panel__conversation {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    padding: 1.25rem;
  }

  div.chat-panel__message {
    animation: chat-sequence-first 9s ease-in-out infinite;
    border-radius: 8px;
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1.35;
    max-width: 82%;
    opacity: 0;
    padding: 0.85rem 1rem;
  }

  div.chat-panel__message--user {
    align-self: flex-end;
    background: #e8f0ff;
    color: #315d9d;
  }

  div.chat-panel__message--agent {
    align-self: flex-start;
    background: #f6f8fb;
    border: 1px solid #d9dee7;
    color: #1f2933;
  }

  div.chat-panel__message:nth-child(2) {
    animation-name: chat-sequence-second;
  }

  div.chat-panel__insight {
    align-items: flex-end;
    animation: chat-sequence-third 9s ease-in-out infinite;
    align-self: flex-start;
    border: 1px solid #d9dee7;
    border-radius: 8px;
    display: flex;
    gap: 0.45rem;
    height: 4.8rem;
    opacity: 0;
    padding: 0.8rem;
    width: 11rem;

    span {
      width: 2rem;
      border-radius: 4px 4px 0 0;
      background: #3d69ad;
      animation: chart-grow 2.4s ease-in-out infinite;

      &:nth-child(1) {
        height: 45%;
      }

      &:nth-child(2) {
        height: 72%;
        animation-delay: 0.25s;
      }

      &:nth-child(3) {
        height: 58%;
        background: #008a78;
        animation-delay: 0.5s;
      }
    }
  }

  div.chat-panel__message:nth-child(4) {
    animation-name: chat-sequence-fourth;
  }

  div.impact-panel {
    width: 86%;
    min-height: 32rem;
    border: 1px solid #d9dee7;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 2rem 5rem rgba(31, 52, 79, 0.16);
    display: grid;
    grid-template-columns: 5rem 1fr;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 4rem;
    z-index: 2;
  }

  div.impact-panel__sidebar {
    background: #1f344f;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem 1rem;

    span {
      height: 0.8rem;
      border-radius: 999px;
      background: #40516a;

      &:first-child {
        background: #ffffff;
        width: 1.2rem;
      }
    }
  }

  div.impact-panel__content {
    padding: clamp(1.5rem, 4vw, 3rem);
  }

  div.impact-panel__header {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    color: #111820;
    line-height: 1.1;
    margin-bottom: 1.5rem;
    text-align: left;

    strong {
      font-size: clamp(1.8rem, 3vw, 2.7rem);
    }
  }

  span.impact-panel__eyebrow {
    color: #8d49ff;
    font-size: 0.8rem;
    font-weight: 800;
    text-transform: uppercase;
  }

  div.impact-panel__alert {
    height: 2.1rem;
    border-radius: 8px;
    background: #e8f0ff;
    margin-bottom: 1.2rem;
    position: relative;

    &::before {
      content: "";
      width: 42%;
      height: 0.45rem;
      border-radius: 999px;
      background: #3d69ad;
      left: 1rem;
      position: absolute;
      top: 0.85rem;
    }
  }

  div.impact-panel__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    margin: 1.5rem 0;
  }

  div.impact-panel__item {
    min-height: 7rem;
    border: 1px solid #d9dee7;
    border-radius: 8px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    text-align: left;

    span {
      color: #64707d;
      font-size: 0.85rem;
      font-weight: 700;
    }

    strong {
      color: #111820;
      font-size: clamp(1.8rem, 3vw, 2.6rem);
      font-weight: 800;
      line-height: 1;
      margin-top: 0.5rem;
    }
  }

  div.impact-panel__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;

    span {
      border: 1px solid #d9dee7;
      border-radius: 999px;
      color: #315d9d;
      font-size: 0.9rem;
      font-weight: 700;
      padding: 0.5rem 0.8rem;
    }
  }

  @media (max-width: 900px) {
    div.panel-stack {
      min-height: auto;
    }

    div.chat-panel,
    div.impact-panel {
      position: relative;
      top: auto;
      right: auto;
      left: auto;
      transform: none;
      width: 100%;
    }

    div.chat-panel {
      margin-bottom: 1rem;
    }

    div.impact-panel {
      margin-bottom: 1rem;
      grid-template-columns: 1fr;
    }

    div.impact-panel__sidebar {
      display: none;
    }

    div.impact-panel__grid {
      grid-template-columns: 1fr;
    }
  }

  @keyframes chat-pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(141, 73, 255, 0.5);
    }

    70% {
      box-shadow: 0 0 0 0.7rem rgba(141, 73, 255, 0);
    }

    100% {
      box-shadow: 0 0 0 0 rgba(141, 73, 255, 0);
    }
  }

  @keyframes chat-sequence-first {
    0%,
    4% {
      opacity: 0;
      transform: translateY(0.5rem);
    }

    10%,
    84% {
      opacity: 1;
      transform: translateY(0);
    }

    90%,
    100% {
      opacity: 0;
      transform: translateY(0);
    }
  }

  @keyframes chat-sequence-second {
    0%,
    18% {
      opacity: 0;
      transform: translateY(0.5rem);
    }

    24%,
    84% {
      opacity: 1;
      transform: translateY(0);
    }

    90%,
    100% {
      opacity: 0;
      transform: translateY(0);
    }
  }

  @keyframes chat-sequence-third {
    0%,
    32% {
      opacity: 0;
      transform: translateY(0.5rem);
    }

    38%,
    84% {
      opacity: 1;
      transform: translateY(0);
    }

    90%,
    100% {
      opacity: 0;
      transform: translateY(0);
    }
  }

  @keyframes chat-sequence-fourth {
    0%,
    46% {
      opacity: 0;
      transform: translateY(0.5rem);
    }

    52%,
    84% {
      opacity: 1;
      transform: translateY(0);
    }

    90%,
    100% {
      opacity: 0;
      transform: translateY(0);
    }
  }

  @keyframes chart-grow {
    0%,
    100% {
      transform: scaleY(0.82);
      transform-origin: bottom;
    }

    50% {
      transform: scaleY(1);
      transform-origin: bottom;
    }
  }
}
</style>
